import {
  ApiTokenListResponse,
  CalendarEventOccurrence,
  EventOccurrenceDTO,
  TokenPageableRequestParams,
} from "@gymflow/types";
import {
  infiniteQueryOptions,
  QueryKey,
  queryOptions,
} from "@tanstack/react-query";

import { api } from "../../api";
import { tokenPagination } from "../../tokenPagination";

const keys = {
  all: () => ["hostedApiEventOccurrence"] as QueryKey,
  id: (id: unknown) => [...keys.all(), "id", id] as QueryKey,
  list: (filter: unknown) => [...keys.all(), "list", filter] as QueryKey,
};

export const hostedApiEventOccurrence = {
  keys,
  queries: {
    id: (id: number | undefined) =>
      queryOptions({
        queryKey: keys.id(id),
        queryFn: async () => {
          return (
            await api.get<EventOccurrenceDTO>(`/hosted/event/occurrence/${id}`)
          ).data;
        },
        enabled: id !== undefined,
      }),
  },
  infiniteQueries: {
    list: (
      params: {
        dateFrom?: string;
        dateTo?: string;
        includeBookedCounts?: boolean;
        includeWaitingCounts?: boolean;
        eventHostId?: string[];
        facilityId?: number[];
        activityId?: number[];
        isPublicEvent?: boolean;
        activityCategoryId?: number[];
      } & TokenPageableRequestParams,
    ) =>
      infiniteQueryOptions({
        queryKey: keys.list(params),
        queryFn: async ({ pageParam }) => {
          return (
            await api.get<ApiTokenListResponse<CalendarEventOccurrence>>(
              "hosted/calendar/event-occurrences",
              {
                params: {
                  ...params,
                  nextPageToken: pageParam,
                },
              },
            )
          ).data;
        },
        ...tokenPagination,
      }),
  },
  mutations: {},
};
